import React from "react";
import { Box, Typography } from "@mui/material";

type Props = {
  label: string;
  children: React.ReactNode;
};

export const InfoRow: React.FC<Props> = ({ label, children }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "160px 1fr",
      alignItems: "center",
      gap: 1,
    }}
  >
    <Typography variant="caption" fontWeight={500}>
      {label}:
    </Typography>
    <Box>{children}</Box>
  </Box>
);
